<template>
    <div
        v-if="isError"
        class="call-stage call-stage--final"
        data-test="qr-call-final"
    >
        <p class="call-stage__title">{{ $t(errorMessageKey) }}</p>

        <button
            v-if="errorCode !== QR_CALL_ERROR.MIC_REQUIRED"
            class="btn btn-primary w-full"
            @click="$emit('retry')"
        >
            {{ $t('qr.call.try_again') }}
        </button>
        <div class="mt-3 w-full">
            <button
                class="btn btn-secondary w-full"
                data-test="qr-back-to-directory"
                @click="$emit('back')"
            >
                {{ $t('qr.call.back_to_directory') }}
            </button>
        </div>
    </div>

    <div
        v-else-if="overlayMessageKey"
        class="call-stage call-stage--overlay"
        data-test="qr-call-overlay"
    >
        <p class="call-stage__title">{{ $t(overlayMessageKey, { name: displayName }) }}</p>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { QR_CALL_ERROR, QR_CALL_STAGE } from '../../constants/qr';

const props = defineProps({
    stage: {
        type: String,
        required: true,
    },
    displayName: {
        type: String,
        default: '',
    },
    errorCode: {
        type: String,
        default: null,
    },
    reconnecting: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['back', 'retry']);

// Declined, missed and ended calls redirect away from the call view; only errors stay on screen
const isError = computed(() => props.stage === QR_CALL_STAGE.ERROR);
const errorMessageKey = computed(() => `qr.call.errors.${props.errorCode || QR_CALL_ERROR.START_FAILED}`);

const overlayMessageKey = computed(() => {
    if (props.reconnecting) return 'qr.call.reconnecting';
    switch (props.stage) {
    case QR_CALL_STAGE.CONNECTING:
        return 'qr.call.connecting';
    case QR_CALL_STAGE.RINGING:
        return 'qr.call.ringing';
    default:
        return '';
    }
});
</script>

<style scoped>
.call-stage {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.call-stage--overlay {
    color: #fff;
    pointer-events: none;
}

.call-stage--final {
    height: 100%;
    padding: 24px;
}

.call-stage__title {
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 600;
}

.call-stage--final .call-stage__title {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.call-stage--overlay .call-stage__title {
    margin: 0 0 12px;
    font-family: sofia-pro, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 400;
    overflow-wrap: anywhere;
}
</style>
